module.exports = __webpack_public_path__ + "static/media/pic_qjwl@3x.64f0cbca.png";